import fetch from "@/helpers/fetch";
import params from "@/lib/params";

export function getRelationList(query) {
  return fetch.getFast("/api/inspect/multi-unionid-relation", query);
}

export function getInspectDetail(query) {
  return fetch.getFast("/api/inspect/detail", query);
}

export function modifyInspectOrder(content) {
  return fetch.postFast('/api/inspect/modify-inspect-order', null, {
    body: params(content)
  });
}
export function unionidInspect(content) {
  return fetch.postFast('/api/inspect/unionid-inspect', null, {
    body: params(content)
  });
}

export function getLiveInspectors(query) {
  return fetch.getFast("/api/inspect/live-inspectors", query);
}

export function submitInspect(query) {
  return fetch.postFast('/api/inspect/submit-inspect', null, {
    body: params(query)
  });
}

export function modifyInspect(query) {
  return fetch.postFast('/api/inspect/modify-inspect', null, {
    body: params(query)
  });
}

export function submitCurate(query) {
  return fetch.postFast('/api/inspect/submit-curate', null, {
    body: params(query)
  });
}

export function searchUser(query) {
  return fetch.getFast('/staff/info/user-info-by-name-or-no', query);
}

export function getReovkePunishNotice(query) {
  return fetch.getFast('/api/inspect/reovke-punish-notice', query);
}

// 违规标记详情
export function violationTagDetail(query) {
  return fetch.getFast('/api/inspect/violation-tag-detail', query);
}

// 违规聊天详情
export function violationChatDetail(query) {
  return fetch.postFast('/api/inspect/violation-chat-detail', null, {
    body: params(query)
  });
}

// 违规聊天标记
export function violationChatMark(query) {
  return fetch.getFast('/api/inspect/violation-chat-mark', query);
}


